import Vue from 'vue';
import VuetifyToast from 'vuetify-toast-snackbar'
import PortalVue from 'portal-vue'
import { firestorePlugin, rtdbPlugin } from 'vuefire'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VueTheMask from 'vue-the-mask'
import VueAnime from 'vue-animejs'
import Chat from 'vue-beautiful-chat'
import App from './App.vue';
import PageTemplate from './components/layout/PageTemplate.vue'
import CHalf from './components/layout/CHalf.vue'
import CWhole from './components/layout/CWhole.vue'

import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify'
import './firebase/init'
import './firebase/authentication'
import './plugins/vee-validate'


Vue.config.productionTip = false;

Vue.component('page-template', PageTemplate)
Vue.component('CHalf', CHalf)
Vue.component('CWhole', CWhole)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.use(VuetifyToast)
Vue.use(PortalVue)
Vue.use(firestorePlugin)
Vue.use(rtdbPlugin)
Vue.use(VueTheMask)
Vue.use(VueAnime)
// @ts-ignore
Vue.use(Chat)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
